"use strict";

import "core-js/modules/es.symbol.description.js";
import { CDN } from '@autoguru/global-configs';
export const slideDuration = 6;
export const genericContent = [{
  title: 'One portal to manage all fleet vehicles',
  description: 'One login, multiple bookings. Coordinate effortlessly with fleet controllers from different fleet companies in one portal. Standardising the process for more efficient approvals.',
  altImg: 'multiple bookings'
}, {
  title: 'One portal for faster approvals and payments',
  description: 'No more twiddling thumbs. With AutoGuru’s Supplier Portal your fleet bookings get approved and payments processed swiftly. Get your customers’ vehicles on the road quicker!',
  altImg: 'approvals and payments'
}, {
  title: 'One portal to reduce your time on the phones',
  description: 'Say good-bye to hold music! Drastically reduce your time on the phone by submitting and tracking bookings online. Use saved time for more important tasks.',
  altImg: 'reduce your time on phones'
}];
export const carouselDesktopContent = [{
  title: genericContent[0].title,
  description: genericContent[0].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-desktop-1.png`,
  uspAltImg: genericContent[0].altImg,
  uspImgWidth: 926,
  uspImgHeight: 525,
  aspectRatio: 926 / 525
}, {
  title: genericContent[1].title,
  description: genericContent[1].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-desktop-2.png`,
  uspAltImg: genericContent[1].altImg,
  uspImgWidth: 900,
  uspImgHeight: 525,
  aspectRatio: 900 / 525
}, {
  title: genericContent[2].title,
  description: genericContent[2].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-desktop-3.png`,
  uspAltImg: genericContent[2].altImg,
  uspImgWidth: 902,
  uspImgHeight: 525,
  aspectRatio: 902 / 525
}];
export const carouselMobileContent = [{
  title: genericContent[0].title,
  description: genericContent[0].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-mobile-1.png`,
  uspAltImg: genericContent[0].altImg,
  uspImgWidth: 686,
  uspImgHeight: 471,
  aspectRatio: 686 / 471
}, {
  title: genericContent[1].title,
  description: genericContent[1].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-mobile-2.png`,
  uspAltImg: genericContent[1].altImg,
  uspImgWidth: 686,
  uspImgHeight: 464,
  aspectRatio: 686 / 464
}, {
  title: genericContent[2].title,
  description: genericContent[2].description,
  uspImgPath: `${CDN}/images/nz/landing/usp-mobile-3.png`,
  uspAltImg: genericContent[2].altImg,
  uspImgWidth: 686,
  uspImgHeight: 345,
  aspectRatio: 686 / 345
}];